/**
 * Addressbook CopilotKit Readable State
 */

import { useCopilotReadable } from '@copilotkit/react-core'
import { useSelector } from '@ufc/core'
import { selectFilteredAddresses, selectAddressStats } from '../store/addressbook.selectors'

export function useAddressbookReadable() {
  const addresses = useSelector(selectFilteredAddresses)
  const stats = useSelector(selectAddressStats)

  useCopilotReadable({ description: 'Address list', value: addresses })
  useCopilotReadable({ description: 'Address statistics', value: stats })
}
